import { Grid, Typography } from "@mui/material";
import React from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useFormContext } from "react-hook-form";
import { WSIcons } from "../../commonFunctions/iIcons";

export const CardInformation: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid container item xs={12} sm={8} alignItems="center" spacing={1}>
        <Grid item xs={12} sm={3}>
          <Typography>Owner Name</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("ownerName")}
            id="ownerName"
            name="ownerName"
            control={control}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography>Card Holder</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("cardholder")}
            id="cardholder"
            name="cardholder"
            control={control}
            rules={{ required: true }}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography>Card Template</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("cardtemplate")}
            id="cardtemplate"
            name="cardtemplate"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
      </Grid>

      {/* Person Icon and Guest Image */}
      <Grid item xs={12} sm={4}>
        <Grid container direction="column" alignItems="center">
          <Grid
            sx={{
              border: "1px solid #ccc", 
              padding: 2, 
              borderRadius: "8px", 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: 120, 
              height: 120, 
              mb: 2, 
            }}
          >
            <WSIcons.Person fontSize="large" />
          </Grid>
          <Typography>Guest Image</Typography>
        </Grid>
      </Grid>
      <Grid container item xs={12}  spacing={1}>

      <Grid item xs={12} sm={2}>
        <Typography>Balance</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("balance")}
            id="balance"
            name="balance"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>--</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("balance--")}
            id="balance--"
            name="balance--"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Point Balance</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("pointbalance")}
            id="pointbalance"
            name="pointbalance"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>Limit</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("limit")}
            id="limit"
            name="limit"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Discount</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("discount")}
            id="discount"
            name="discount"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={3}>
      <Typography>Balance On Credit Limit</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
      <WSTextField
            label={""}
            {...register("balancecreditlimit")}
            id="balancecreditlimit"
            name="balancecreditlimit"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Status</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
      <WSTextField
            label={""}
            {...register("status")}
            id="status"
            name="status"
            control={control}
            rules={{ required: true }}
          />
      </Grid>
      </Grid>
    </Grid>
  );
});
